import {ProductCard} from '../ProductCard.jsx';
import {SectionHeader} from '../ui/SectionHeader.jsx';

export function ProductRail({title, subtitle, products, featured = false, to = '/catalog', action = 'More Products'}) {
  if (!products?.length) return null;
  const railName = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  return <section className={`section shell product-section rail-${railName} ${featured ? 'product-section-sale' : ''}`}><SectionHeader title={title} subtitle={subtitle} to={to} action={action}/><div className="product-grid product-rail">{products.map(product => <ProductCard key={product.id} product={product}/>)}</div></section>;
}
